<template>
  <!--面包屑导航-->
  <div class="breadCrumb" :key="breadCrumbKey">
    <div class="wrap-cls">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>网上办事</el-breadcrumb-item>
        <el-breadcrumb-item>部门服务</el-breadcrumb-item>
        <el-breadcrumb-item class="order">{{location}}</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="go-phone-appointment-cls" v-if="isPhoneList">
        <p class="tip-cls">在线预约太麻烦？请点击<i class="el-icon-d-arrow-right"></i></p>
        <button type="button" class="btn-no-style get-phone-btn" @click="goPhoneAppointment">
          大厅电话预约
        </button>
      </div>
    </div>
    <!--虚线分割-->
    <div class="line"></div>
  </div>
</template>
<script>
import { interOutnetConfig } from "../../utils/appointment.url.js";
export default {
  name: "breadCrumb",
  props: ['location', 'isPhoneType', 'areaSeq'],
  data() {
    return {
      breadCrumbKey: false,
      isPhoneList: false
    }
  },
  methods: {
    goPhoneAppointment() {
      let areaSeq = sessionStorage.getItem('areaSeq');
      this.$router.push({
        path: '/phoneAppointment',
        query: {
          areaSeq
        }
      })
    }
  },
  mounted() {
    interOutnetConfig({
        key: "ORDER_TEL_KEY"
      },
      "get"
    ).then(res => {
      if (+res.status === 200) {
        this.isPhoneList = parseInt(res.data.value);
      }
    })
  }
}
</script>
<style lang="scss">
.breadCrumb {
  .el-breadcrumb__item {
    span {
      color: #444444 !important;
      font-size: 16px;
    }
  }

  .order {
    span {
      color: $main-color !important;
    }
  }

  .line {
    margin-top: 10px;
    width: 100%;
    opacity: 0.1;
    border: 1px dashed #000000;
  }

  .wrap-cls {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .go-phone-appointment-cls {
      display: flex;
      align-items: center;

      .tip-cls {
        font-size: 18px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #3E97DF;

        i {
          margin-right: 10px;
          font-size: 22px;
          position: relative;
          top: 2px;
        }
      }

      .get-phone-btn {
        background-color: $main-color;
        border-width: 0;
        color: #fff;
        font-size: 16px;
        padding: 9px 15px;
        border-radius: 3px;
      }
    }
  }

}
</style>